import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Stack, Typography } from '@mui/material';

import { i18nNS } from '../../../i18n';
import AndroidIcon from '../../../icons/AndroidIcon';
import IOSIcon from '../../../icons/IOSIcon';
import WebIcon from '../../../icons/WebIcon';
import { StudentRespondCell, TileImage } from './styles';

export interface TileIntroductionLayoutProps {
  imageSrc: string;
  description: ReactNode;
  /** @default 'primary' */
  color?: 'primary' | 'warning';
  /** @default { iOS: true, android: true, web: true } */
  studentRespondsOn?: {
    iOS: boolean;
    android: boolean;
    web: boolean;
  };
}

const TileIntroductionLayout = ({
  imageSrc,
  description,
  color = 'primary',
  studentRespondsOn = { iOS: true, android: true, web: true },
}: TileIntroductionLayoutProps) => {
  const { t } = useTranslation([i18nNS.SHARED]);

  const { iOS, android, web } = studentRespondsOn;

  return (
    <Stack gap={2}>
      <TileImage src={imageSrc} alt="" />
      <Stack gap={2} color="common.black">
        <Typography variant="paragraphMedium">{description}</Typography>
        <Typography variant="titleBold" component="h6" color={color}>
          {t('students_respond_using', { ns: i18nNS.SHARED })}
        </Typography>
        <Stack gap={1.5} px={2}>
          {iOS && (
            <StudentRespondCell>
              <IOSIcon size={20} />
              <Typography variant="paragraphMedium">{t('acadly_s_i_os_app', { ns: i18nNS.SHARED })}</Typography>
            </StudentRespondCell>
          )}
          {android && (
            <StudentRespondCell>
              <AndroidIcon size={20} />
              <Typography variant="paragraphMedium">{t('acadly_s_android_app', { ns: i18nNS.SHARED })}</Typography>
            </StudentRespondCell>
          )}
          {web && (
            <StudentRespondCell>
              <WebIcon size={20} />
              <Typography variant="paragraphMedium">{t('acadly_s_web_app', { ns: i18nNS.SHARED })}</Typography>
            </StudentRespondCell>
          )}
          {!(iOS || android || web) && (
            <Typography variant="paragraphMedium">{t('responses_not_required', { ns: i18nNS.SHARED })}</Typography>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default TileIntroductionLayout;
